var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// url, ua, ip, user_id, active_timestamp
export function collectActivityStream(userInfo, event, data, analyticsURI) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield fetch(analyticsURI, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    payload: Object.assign({ event, user: userInfo, ua: navigator.userAgent, ip: "127.0.0.1", active_timestamp: Date.now() }, data),
                }),
            });
        }
        catch (err) {
            console.error(`Collect activity stream failed, reason:(${err.message})`);
        }
    });
}
//# sourceMappingURL=collect.utils.js.map